import React, { FC } from 'react';
import { withOptimizely, WithOptimizelyProps } from 'shared/optimizely';

const Header: FC<WithOptimizelyProps> = ({ optimizely }) => {
    const optimizelyVariation = optimizely?.activate('cc_533_rename_discover');

    let headerPath = '/__universal/header.html';

    if (optimizelyVariation === 'control') {
        headerPath = '/__universal/header-cc_533_control.html';
    }

    if (optimizelyVariation === 'news_and_guides') {
        headerPath = '/__universal/header-cc_533_news_and_guides.html';
    }

    return (
        <div
            data-testid="universal-header"
            dangerouslySetInnerHTML={{
                __html: `<!--# block name="header_fallback" --><!--# endblock --><!--# include virtual="${headerPath}" stub="header_fallback" -->`
            }}
        />
    );
};

export default withOptimizely(Header);
